import { apiFetch, HttpError } from "~/api-fetch/apiFetch";
import { reportError } from "~/error-handler/reportError";
import { Authorizations, GetAuthorizationsAsync } from "./types";

export const defaultGetAuthorizationsAsync: GetAuthorizationsAsync = async (
  token,
  impersonatedEmployeeEmail?
) => {
  const res = await apiFetch(
    "/api/authcheck",
    {
      headers: {
        Authorization: `Bearer ${token}`,
        Impersonation: impersonatedEmployeeEmail ?? "",
      },
    },
    { operation: "authcheck" }
  );
  if (res.status === 200) {
    return (await res.json()) as Authorizations;
  } else {
    reportError(HttpError.fromResponse(res));
    return null;
  }
};
